import React from 'react';

class NotFoundPage extends React.Component {
  render() {
    return <h2>Resource not found</h2>;
  }
}

export default NotFoundPage;